export const LS_KEY_TOKEN = 'jwtToken';
